import React, { useState } from 'react';
import styled from 'styled-components';

import CompanyPhoneNumber from 'src/models/CompanyPhoneNumber/CompanyPhoneNumber';
import PaginateLight from '@ad-scripts/presentation/components/common/paginate_light';
import Table from 'src/presentation/components/pages/shared/Table';
import { Button } from 'src/presentation/components/agent_desktop_components';
import { EmptyStateView, CapabilitiesIcons, getCityWithRegion } from '../components';
import { TH, TD } from '@ad-scripts/presentation/components/common/table';
import { formatPhone } from 'src/actions/shared/phonesHelper';

type PropsType = {
  handleSelectPhone: Function;
  isLoading: boolean;
  isPersisting?: boolean;
  items: CompanyPhoneNumber[];
  searchString: string;
};

const columnConfig = [
  {
    attr: 'phoneNumber',
    label: 'Phone number',
    customColumnStyle: () => ({ width: '213px' }),
    customRenderer: item => (item.phoneNumber ? formatPhone(item.phoneNumber) : ''),
  },
  {
    attr: 'locality',
    label: 'City',
    customColumnStyle: () => ({ width: '219px' }),
    customRenderer: item => getCityWithRegion(item),
  },
  {
    attr: 'capabilities',
    label: 'Capabilities',
    customColumnStyle: () => ({ width: '208px' }),
    customRenderer: ({ capabilities }) => <CapabilitiesIcons capabilities={capabilities} />,
  },
];

const initialSorting = { attr: 'phoneNumber' };
const pagination = { pageSize: 5 };

export default function TablePhoneNumbers({
  handleSelectPhone,
  isLoading,
  isPersisting,
  items,
  searchString,
}: PropsType) {
  const [currentPage, updatePage] = useState(1);
  const itemsPerPage = 5;
  const dataAid = 'phone-numbers';

  const renderRowActions = ({ item }) => (
    <StyledButton
      data-aid={`selectPhone-${item.phoneNumber}`}
      type={Button.Types.SECONDARY}
      onClick={() => handleSelectPhone(item)}
      disabled={isPersisting}
    >
      Select number
    </StyledButton>
  );

  return (
    <StyledWrapper>
      <StyledHeaderRow>
        <PaginateLight
          currentPage={currentPage}
          list={items}
          onChange={updatePage}
          pageSize={itemsPerPage}
          showPagination
          title="numbers"
        />
      </StyledHeaderRow>
      <Table
        columnConfig={columnConfig}
        currentPage={currentPage}
        dataAid={dataAid}
        initialSorting={initialSorting}
        isLoading={isLoading}
        items={items}
        pagination={pagination}
        renderRowActions={renderRowActions}
      />
      {!items.length && searchString && <EmptyStateView searchText={searchString} filterType="LOCALITY" />}
    </StyledWrapper>
  );
}

const StyledHeaderRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 ${({ theme }) => theme.spacing.insetLarge};
`;

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 321px;
  max-width: 800px;
  margin-bottom: 0;

  ${TH} {
    padding: ${({ theme }) => theme.spacing.medium};
  }

  ${TD} {
    padding: ${({ theme }) => theme.spacing.medium};
  }
`;

const StyledButton = styled(Button)`
  line-height: 1.1;
`;
